import {useContext} from 'react';
import {
    CModal,
    CModalBody,
    CSpinner
} from "@coreui/react-pro";
import {AppContext} from "../contexts/App";

export function ModelRefresh(){

    const { visibleModalRefresh,  } = useContext(AppContext)

    return(<CModal portal backdrop={'static'} size='sm' alignment='center' visible={visibleModalRefresh}>
        <CModalBody >
            <div className={'text-center'}>
                <span><CSpinner size={"sm"}/> Refresh token...</span>
            </div>
        </CModalBody>
    </CModal>)
}